import type { ReactNode } from 'react'
import type { Auswertung } from '../api'

/** Reihenfolge und Sichtbarkeit kommen ausschließlich aus dem Katalog. */
export function Auswertungsraster({ kacheln, inhalt }: {
  kacheln: Auswertung[]
  inhalt: Record<string, () => ReactNode>
}) {
  const aktive = kacheln.filter((k) => k.aktiv)
  if (!aktive.length) {
    return <div className="karte"><div className="leer">In dieser Ansicht sind keine Kacheln eingeschaltet.</div></div>
  }
  return (
    <div className="auswertungsraster">
      {aktive.map((k) => (
        <div key={k.schluessel}
             className={`auswertung breite-${k.breite}`}
             data-auswertung={k.schluessel}>
          {inhalt[k.schluessel]?.()}
        </div>
      ))}
    </div>
  )
}
